import { deriveZoneGap } from "../../services/retroDerivations";

export default function ZoneProgressCard({ zone }) {
  const gap = deriveZoneGap(zone);
  const currentIdx = zone.levels.indexOf(zone.current);

  return (
    <div className="rtv2-zone">
      <div className="rtv2-zone-head">
        <div className="rtv2-zone-cur">
          <span className="k">You are here</span>
          <span className="v">{zone.current}</span>
        </div>
        <div className="rtv2-zone-gap">
          <span className="arr">→</span>
          <b>{gap} zone{gap === 1 ? "" : "s"}</b> away
        </div>
        <div className="rtv2-zone-tgt">
          <span className="k">Role target</span>
          <span className="v">{zone.target}</span>
        </div>
      </div>
      <div className="rtv2-zone-track">
        {zone.levels.map((lvl, idx) => {
          const curr = lvl === zone.current;
          const tgt = lvl === zone.target;
          const cls = curr ? "current" : tgt ? "target" : (currentIdx > idx ? "passed" : "future");
          return (
            <div key={lvl} className={`rtv2-zone-step ${cls}`}>
              <span className="ord">
                <span className="pip" />
                {String(idx + 1).padStart(2, "0")}
              </span>
              <span className="nm">{lvl}</span>
              {curr ? <span className="badge">You</span> : null}
              {!curr && tgt ? <span className="badge">Target</span> : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}
